import React from 'react';
import { useParticipantFieldsByName } from '@app/api';
import { getParticipantFieldInput } from '@app/participant-fields';

interface Props {
  fieldName: string;
}

export const ParticipantInputByName = ({ fieldName }: Props) => {
  const participantFieldsByName = useParticipantFieldsByName();
  const field = participantFieldsByName[fieldName];
  if (!field) {
    return null;
  }
  const ParticipantInput = getParticipantFieldInput(field);
  if (!ParticipantInput) {
    return null;
  }
  return (
    <ParticipantInput
      field={field}
      label={field.label}
      disabled={!!field.readOnly}
      key={field.name}
    />
  );
};
